module.exports = __webpack_public_path__ + "img/filter-intensity-middle--active.e4da14eb.svg";